import { Node_Type } from 'ricos-schema';

const REMOVE_LINK_PREVIEW = "remove-link-preview";
var LinkPreviewProviders = /* @__PURE__ */ ((LinkPreviewProviders2) => {
  LinkPreviewProviders2["Instagram"] = "Instagram";
  LinkPreviewProviders2["Twitter"] = "Twitter";
  LinkPreviewProviders2["YouTube"] = "YouTube";
  LinkPreviewProviders2["TikTok"] = "TikTok";
  return LinkPreviewProviders2;
})(LinkPreviewProviders || {});
const modalContentStyles = {
  width: 363,
  height: 180,
  padding: 20,
  boxSizing: "border-box",
  border: "solid 1px rgba(51, 51, 51, 0.1)",
  borderRadius: "var(--ricos-settings-whitebox-border-radius, 2px)",
  boxShadow: "var(--ricos-settings-whitebox-box-shadow, 0 0 10px 0 rgba(0, 0, 0, 0.06))"
};
const socialModals = {
  instagram: `${Node_Type.LINK_PREVIEW}.instagram`,
  facebook: `${Node_Type.LINK_PREVIEW}.facebook`,
  tiktok: `${Node_Type.LINK_PREVIEW}.tiktok`,
  twitter: `${Node_Type.LINK_PREVIEW}.twitter`,
  pinterest: `${Node_Type.LINK_PREVIEW}.pinterest`
};
const linkPreviewModals = {
  settings: `${Node_Type.LINK_PREVIEW}.settings`
};

export { LinkPreviewProviders, REMOVE_LINK_PREVIEW, linkPreviewModals, modalContentStyles, socialModals };
//# sourceMappingURL=consts.js.map
